import Vue from 'vue'

const COMPANY_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};

const COMPANY_SET_ADDITIONAL_NAME =(state, payload)=> {
            
    state.data.additional_name = payload
};
const COMPANY_SET_WEB =(state, payload)=> {
            
    state.data.web = payload
};

const COMPANY_SET_PHONE =(state, payload)=> {
            
    state.data.phone = payload
};

const COMPANY_SET_MOBILE =(state, payload)=> {
            
    state.data.mobile = payload
};

const COMPANY_SET_FAX =(state, payload)=> {
            
    state.data.fax = payload
};

const COMPANY_SET_EMAIL =(state, payload)=> {
            
    state.data.email = payload
};

const COMPANY_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const COMPANY_SET_ADRESS =(state, payload)=> {
        
    state.data.adress_id = payload
   
   
};

const COMPANY_SET_COMPANYCATEGORY =(state, payload)=> {
       
    state.data.companycategory_id = payload    
   
};

const COMPANY_SET_ENTITIES =(state, payload)=> {
    
    if(payload!=null) payload=payload.id
    state.data.entity_ids = payload
    state.data.entities = payload   
   
};


const COMPANY_SET_COMPANIES =(state, payload)=> {  
    
    state.companies=payload
    
};

const COMPANY_SET_COMPANY =(state, payload)=> {       
    
    state.data.name = payload.name
    state.data.additional_name = payload.addtional_name
    state.data.web = payload.web
    state.data.email = payload.email
    state.data.fax = payload.fax
    state.data.mobile = payload.mobile
    state.data.phone = payload.phone                               
    state.data.adress_id=payload.adress_id
    state.data.adress=payload.adress
    state.data.companycategory_id =payload.companycategory_id
    
};

const COMPANY_INIT_COMPANY =(state, payload)=> {       
    state.data.name = ''
    state.data.addtional_name = ''
    state.data.web = ''
    state.data.email = ''
    state.data.phone = ''
    state.data.fax = ''
    state.data.mobile = ''       
    state.data.companycategory_id = null
    state.data.adress_id=null,
    state.data.adress=null
};



export default {
  COMPANY_SET_NAME,
  COMPANY_SET_ADDITIONAL_NAME,
  COMPANY_SET_WEB,
  COMPANY_SET_EMAIL,
  COMPANY_SET_PHONE,
  COMPANY_SET_FAX,
  COMPANY_SET_MOBILE,
  COMPANY_SET_ADRESS,
  COMPANY_SET_COMPANYCATEGORY,
  COMPANY_SET_DUPLICATE,
  COMPANY_SET_COMPANIES,
  COMPANY_SET_COMPANY,
  COMPANY_INIT_COMPANY
};